import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import { Card, ExpandingText } from "@totalsoft/rocket-ui";
import { BreakSpan, CorrelationSpan, LogPropertyContainer } from "./LogStyles";

const ItemComponent = ({ item }) => {
  const { t } = useTranslation();

  const onOpenDetails = logId => e => {
    e.stopPropagation();
    window.open(`/logs/${logId}`, "_blank");
  };

  return (
    <Card disablePadding>
      <Grid container spacing={2} px={3} py={2}>
        <LogPropertyContainer item xs={12} md={2} sm={6}>
          <BreakSpan>
            <strong>{item.level}</strong> (
            <CorrelationSpan onClick={onOpenDetails(item.id)}>Id: {item.id} </CorrelationSpan>)
          </BreakSpan>
        </LogPropertyContainer>

        <LogPropertyContainer item xs={12} md={4} sm={6}>
          {item.correlationId && (
            <>
              <strong>{t("Logs.CorrelationId")}</strong>: <BreakSpan>{item.correlationId}</BreakSpan>
            </>
          )}
        </LogPropertyContainer>

        <Grid item xs={12} md={6}>
          {item.logEvent ? <BreakSpan>{<ExpandingText minLength={85} text={item.logEvent} />}</BreakSpan> : ""}
        </Grid>
      </Grid>
    </Card>
  );
};

ItemComponent.propTypes = {
  item: PropTypes.object.isRequired
};

export default ItemComponent;
